import { DataBean } from "../DataBean";

export class CreateProductRowvDOS extends DataBean {
    
    


    public async createProductRow(idProduct:any,idStore:any,quantity:any,totalValue:any,applyTaxes:any,productValueType:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "inventory.Product_createProductRow_Number_Number_Number_Number_Boolean_Number", [idProduct,idStore,quantity,totalValue,applyTaxes,productValueType]);
    }

    // public async createProductRowForOutput(idProduct:any,idProductVariant:any,idStore:any,quantity:any,idProductionOrder:any,productionOrderDate:any,idLot:any): Promise<any> {
    //     return this.getCustomService("QuickDataERPCore", "inventory.Product_createProductRowForOutput_Number_Number_Number_Number_Number_java.util.Date_Number", [idProduct,idProductVariant,idStore,quantity,idProductionOrder,productionOrderDate,idLot]);
    // }
    public async createProductRowForRawMaterialToProductionLine (idProductionOrder:any,year:any,idProduct:any,quantity:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "inventory.Product_createProductRowForRawMaterialToProductionLine_Number_Number_Number_Number", [idProductionOrder,year,idProduct,quantity]);
    }

     public async createProductRowForRawMaterialToProductionLinewhitstore (idProductionOrder:any,year:any,idProduct:any,quantity:any,idStore:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "inventory.Product_createProductRowForRawMaterialToProductionLine_Number_Number_Number_Number_Number", [idProductionOrder,year,idProduct,quantity,idStore]);
    }
  public async createProductRowForRawMaterialToProductionLineForDevolution (idProductionOrder:any,year:any,idProduct:any,quantity:any,idStore:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "inventory.Product_createProductRowForRawMaterialToProductionLineForDevolution_Number_Number_Number_Number_Number", [idProductionOrder,year,idProduct,quantity,idStore]);
    }

      public async createProductRowForRawMaterialFromRequest(idRawMaterialRequest:any,idRawMaterial:any,idProductRef:any,idStore:any,quantity:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "inventory.Product_createProductRowForRawMaterialFromRequest_Number_Number_Number_Number_Number", [idRawMaterialRequest,idRawMaterial,idProductRef,idStore,quantity]);
    }

    public async createProductRowForOutput(idProduct:any,idStore:any,quantity:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "inventory.Product_createProductRowForOutput_Number_Number_Number", [idProduct,idStore,quantity]);
    }

    public async createProductRowForOutputByProductLot(idlot:any,idStore:any,quantity:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "inventory.Product_createProductRowForOutputByProductLot_Number_Number_Number", [idlot,idStore,quantity]);
    }

    public async getProductValueTypeConstants(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductValueTypeConstants_Number", [id]);
    }

    public async createProductRowForFinishedProductionOrder(idProductionOrder:any,productionOrderDate:any,quantity:any,description:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "inventory.Product_createProductRowForFinishedProductionOrder_Number_java.util.Date_Number_String", [idProductionOrder,productionOrderDate,quantity,description]);
    }
  
    public async createProductRowForRawMaterial(idProductionOrder:any,productionOrderDate:any,idRawMaterial:any,idProductRef:any,idStore:any,quantity:number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "inventory.Product_createProductRowForRawMaterial_Number_java.util.Date_Number_Number_Number_Number", [idProductionOrder,productionOrderDate,idRawMaterial,idProductRef,idStore,quantity]);
    }

}